var _matomoTrackerLoaded = false;

/**
 * An object to manage Matomo tracking
 * @constructs MatomoTracker
 * @memberof Class
 * @author Andreï Cavoleau
 */
function MatomoTracker(config) {
	/*
	  For Matomo, all 3 properties are needed,
	  for Matomo Tag Manager, only scriptUrl is needed
	*/
	this.siteId = config.id;
	this.trackerUrl = config.trackerUrl;
	this.scriptUrl = config.scriptUrl;
	this.loadTracker();
}

MatomoTracker.prototype.isLoaded = function () {
	return _matomoTrackerLoaded;
}

/**
 * Load the Matomo tracker
 * @author Andreï Cavoleau
 */
MatomoTracker.prototype.loadTracker = function () {

	if (_matomoTrackerLoaded) {
		return;
	}

	window._paq = window._paq || [];
	window._paq.push(['enableLinkTracking']);
	if (this.trackerUrl) {
		window._paq.push(['setTrackerUrl', this.trackerUrl]);
	}
	if (this.siteId) {
		window._paq.push(['setSiteId', this.siteId]);
	}
	var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
	g.async = true; 
	g.src = this.scriptUrl; 
	s.parentNode.insertBefore(g, s);

	_matomoTrackerLoaded = true;

};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} url   The URL of the page viewed
 * @param  {String} title The page title
 * @author Andreï Cavoleau
 */
MatomoTracker.prototype.trackPage = function (page, url, title) {
	window._paq.push(['setCustomUrl', url]);
	window._paq.push(['setDocumentTitle', title]);
	window._paq.push(['trackPageView']);
};

/**
 * Track a page event
 * @param  {String}  category The event category
 * @param  {String}  action   The event name
 * @param  {String}  label    The action label
 * @param  {integer} value    A complementary figure
 * @author Andreï Cavoleau
 */
MatomoTracker.prototype.trackEvent = function (category, action, label, value) {
	window._paq.push(['trackEvent', category, action, label, value]);
};

module.exports = MatomoTracker;



//////////////////
// WEBPACK FOOTER
// ./src/utils/statistics/trackers/matomoTracker.js
// module id = 787
// module chunks = 0